import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';

type DurumTipi = 'aktif' | 'uyari' | 'hata' | 'pasif';

const RENK_HARITASI: Record<DurumTipi, string> = {
  aktif: '#52c41a',
  uyari: '#faad14',
  hata: '#f5222d',
  pasif: '#8c8c8c',
};

@Component({
  selector: 'widget-durum-dot',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="durum-dot-wrap">
      <span
        class="dot"
        [class.pulse]="durum() === 'aktif'"
        [style.background]="renk()"
        [style.box-shadow]="'0 0 6px ' + renk()">
      </span>
      @if (etiket()) {
        <span class="etiket">{{ etiket() }}</span>
      }
    </div>
  `,
  styles: [`
    :host { display: inline-block; }
    .durum-dot-wrap { display: inline-flex; align-items: center; gap: 8px; }
    .dot {
      width: 12px; height: 12px; border-radius: 50%; flex-shrink: 0;
      transition: background 0.3s, box-shadow 0.3s;
    }
    .dot.pulse { animation: durum-pulse 1.5s ease-in-out infinite; }
    .etiket { font-size: 0.85em; color: var(--py-metin, #e0e0e0); }
    @keyframes durum-pulse {
      0%, 100% { transform: scale(1); opacity: 1; }
      50% { transform: scale(1.4); opacity: 0.6; }
    }
  `],
})
export class DurumDotComponent {
  durum = input<DurumTipi>('pasif');
  etiket = input('');

  renk = computed(() => RENK_HARITASI[this.durum()] || RENK_HARITASI.pasif);
}
